import { ISize } from './dimension';

export interface IImage {
    width: number;
    height: number;
    url: string;
    id?: string;
}

export interface IImageAsset {
    id: string;
    original: IImage;
    thumbnail: IImage;
    fileSize: number;
    name: string;
    width?: number;
    height?: number;
}

export interface IImageSize {
    width: number;
    height: number;
    readonly src: string;
}

export interface IImageSizes {
    original: IImageSize;
}

export function createSVGLoaderImage(size: ISize): SVGGElement {

    const svgNamespace = 'http://www.w3.org/2000/svg';

    const wrapperGroup = document.createElementNS(svgNamespace, 'g');

    const circleGroup = document.createElementNS(svgNamespace, 'g');
    circleGroup.setAttribute('transform', `translate(${(size.width / 2) - 12}, ${(size.height / 2) - 12})`);
    circleGroup.setAttribute('stroke', '#ffffff');
    circleGroup.setAttribute('stroke-width', '2');
    circleGroup.setAttribute('fill', 'none');

    const circleElement = document.createElementNS(svgNamespace, 'circle');
    circleElement.setAttribute('stroke-opacity', '0.25');
    circleElement.setAttribute('cx', '12');
    circleElement.setAttribute('cy', '12');
    circleElement.setAttribute('r', '12');

    const pathElement = document.createElementNS(svgNamespace, 'path');
    pathElement.setAttribute('d', 'M24 12c0-9.94-8.06-12-12-12');

    const animateTransform = document.createElementNS(svgNamespace, 'animateTransform');
    animateTransform.setAttribute('attributeName', 'transform');
    animateTransform.setAttribute('type', 'rotate');
    animateTransform.setAttribute('from', '0 12 12');
    animateTransform.setAttribute('to', '360 12 12');
    animateTransform.setAttribute('dur', '1s');
    animateTransform.setAttribute('repeatCount', 'indefinite');

    pathElement.appendChild(animateTransform);

    circleGroup.appendChild(circleElement);
    circleGroup.appendChild(pathElement);

    const backgroundElement = document.createElementNS(svgNamespace, 'rect');
    backgroundElement.setAttribute('width', `${size.width}`);
    backgroundElement.setAttribute('height', `${size.height}`);
    backgroundElement.setAttribute('fill', 'rgba(0,0,0,0.25)');

    wrapperGroup.appendChild(backgroundElement);
    wrapperGroup.appendChild(circleGroup);

    return wrapperGroup;
}
